import { WebClient } from "@cisco/spaces-dash-lib-web";
import type {
  GetDashboardPropertiesResponse,
  CheckPartnerAppResponse,
  CheckPartnerLicenseAgreedResponse,
  FetchAccountsResponse,
  SelfOnboardingResponse,
  GetEndUserLicenseAgreementResponse,
  UpdatePartnerLicenseResponse
} from "../types/services";
import type { HttpOptions, SelfOnboardingPayload, LicenseUpdatePayload } from "../types";

const API_BASE_URL = "/api/v1";
const TM_BASE_URL = "/api/tm/v1";

const GET_DASHBOARD_PROPERTIES = "/client/properties";
const GET_PARTNER = "/partnerapps/partner";
const CHECK_PARTNER_LICENSE_STATUS = "/partnerapps/license/status";
const UPDATE_PARTNER_LICENSE = "/partnerapps/license/update";
const GET_ACCOUNTS = "/account/assigned";
const SELF_ONBOARD_PARTNER = "/partnerapps/selfOnBoarding";
const END_USER_LICENSE_AGREEMENT = "/partnerapps/doc/license";

const OPTIONS: HttpOptions = {
  credentials: "include",
  mode: "cors",
  cache: "no-cache",
  redirect: "follow",
  referrerPolicy: "no-referrer",
  headers: {
    Accept: "application/json"
  }
};

const getSandboxParamUrl = (url: string, type: "get" | "post", postParams: Record<string, unknown> = {}): string | Record<string, unknown> => {
  if (type === "get") {
    const urlObj = new URL(url, window.location.origin);
    urlObj.searchParams.set("isSandbox", "true");
    return urlObj.toString();
  }

  // For 'post' type, set or create the postParams object
  return {
    ...postParams,
    isSandbox: true
  };
};

export const getDashboardProperties = (): GetDashboardPropertiesResponse => {
  return WebClient.get(`${API_BASE_URL}${GET_DASHBOARD_PROPERTIES}?t=${new Date().getTime()}`, OPTIONS);
};

export const checkPartnerApp = (tenantId: string, region: string): CheckPartnerAppResponse => {
  const url = getSandboxParamUrl(`${API_BASE_URL}${GET_PARTNER}?tenantId=${tenantId}&region=${region}`, "get") as string;

  return WebClient.get(url, OPTIONS);
};

export const checkPartnerLicenseAgreed = (tenantId: string, licenseVersion: string, setup: string): CheckPartnerLicenseAgreedResponse => {
  const url = getSandboxParamUrl(`${API_BASE_URL}${CHECK_PARTNER_LICENSE_STATUS}?tenantId=${tenantId}&version=${licenseVersion}&region=${setup}`, "get") as string;

  return WebClient.get(url, OPTIONS);
};

export const fetchAccounts = (): FetchAccountsResponse => {
  return WebClient.get(`${TM_BASE_URL}${GET_ACCOUNTS}`, OPTIONS);
};

export const selfOnBoarding = (payload: SelfOnboardingPayload): SelfOnboardingResponse => {
  const url = `${API_BASE_URL}${SELF_ONBOARD_PARTNER}`;
  const sandboxPayload = getSandboxParamUrl(url, "post", payload);
  return WebClient.post(url, OPTIONS, sandboxPayload);
};

export const getEndUserLicenseAgreement = (): GetEndUserLicenseAgreementResponse => {
  const url = getSandboxParamUrl(`${API_BASE_URL}${END_USER_LICENSE_AGREEMENT}`, "get", {}) as string;
  return WebClient.get(url, OPTIONS);
};

export const updatePartnerLicenseCall = (payload: LicenseUpdatePayload): UpdatePartnerLicenseResponse => {
  const url = `${API_BASE_URL}${UPDATE_PARTNER_LICENSE}`;
  const sandboxPayload = getSandboxParamUrl(url, "post", payload);
  return WebClient.post(url, OPTIONS, sandboxPayload);
};
